import { mergeAskPayloadAccessContext } from "../../account/src/api/askIQApi";

/**
 * Build a get_suggestions/ payload for IQ controlled suggestion overlays.
 * Always merges account_id and access_id from local storage (required for refinement sessions).
 */
export function buildIQSuggestionPayload({
  prompt,
  suggestionType,
  roleId = null,
  responsibilityId = null,
  positionId = null,
  startNew = false,
}) {
  const payload = {
    prompt,
    suggestion_type: suggestionType,
    start_new: startNew ? 1 : 0,
  };

  if (roleId != null) {
    payload.role_id = roleId;
  }
  if (responsibilityId != null) {
    payload.responsibility_id = responsibilityId;
  }
  if (positionId != null) {
    payload.position_id = positionId;
  }

  return mergeAskPayloadAccessContext(payload);
}

/**
 * Build a get_suggestions/ payload for the Import Job Description benchmark
 * review steps (Rules 15 & 16). Includes the Position title as context, as the
 * rules page specifies.
 */
export function buildPositionImportBenchmarkPayload({
  prompt,
  suggestionType,
  positionId = null,
  positionTitle = "",
  startNew = false,
}) {
  const payload = {
    prompt,
    suggestion_type: suggestionType,
    start_new: startNew ? 1 : 0,
  };

  if (positionId != null) {
    payload.position_id = positionId;
  }
  if (positionTitle) {
    payload.position_title = positionTitle;
  }

  return mergeAskPayloadAccessContext(payload);
}

export function isControlledIQSuggestOverlayType(type) {
  return type === "roleResponsibility" || type === "responsibilityCheckpoint";
}

export function suggestionTypeForOverlayType(type) {
  if (type === "roleResponsibility") {
    return "role_responsibilities";
  }
  if (type === "responsibilityCheckpoint") {
    return "responsibility_checkpoint_criteria";
  }
  return null;
}

export const POSITION_IMPORT_SUGGESTION_TYPES = Object.freeze({
  IMPROVEMENT: "position_import_benchmark_improvement",
  MISSING: "position_import_benchmark_missing",
});
